import { render, staticRenderFns } from "./coachPlan.vue?vue&type=template&id=672b08ce&"
import script from "./coachPlan.vue?vue&type=script&lang=js&"
export * from "./coachPlan.vue?vue&type=script&lang=js&"
import style0 from "./coachPlan.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports